<template>
  <div class="personnel-conges-view">
    <Header title="Gestion des congés" />
    
    <div class="personnel-content">
      <h4>🏝️ Gestion des congés et absences</h4>
      
      <div class="actions-bar">
        <router-link to="/personnel/conges/quotas" class="btn btn-primary">
          <span class="material-icons">event_note</span>
          Gestion des quotas de congés
        </router-link>
        <router-link to="/personnel/conges/calendrier" class="btn btn-turquoise">
          <span class="material-icons">calendar_month</span>
          Calendrier des congés
        </router-link>
      </div>
      
      <div class="content-placeholder">
        <div class="placeholder-icon">
          <span class="material-icons">beach_access</span>
        </div>
        <h3>Gestion des congés</h3>
        <p>Cette fonctionnalité est en cours de développement.</p>
        <p>Le module permettra de gérer les demandes et approbations de congés des agents.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import Header from '@/components/Header.vue'

onMounted(() => {
  //console.log('PersonnelCongesView mounted')
})
</script>

<style scoped>
.personnel-conges-view {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.personnel-content {
  flex: 1;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.personnel-content h4 {
  font-size: 1.3rem;
  color: #455a64;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.actions-bar {
  display: flex;
  justify-content: flex-start;
  gap: 12px;
  margin-bottom: 20px;
}

.btn-primary {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(to right, var(--turquoise-deep), var(--turquoise-primary));
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.btn-primary:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
  background: linear-gradient(to right, var(--turquoise-primary), var(--turquoise-deep));
}

.btn-turquoise {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: var(--turquoise-primary, #30C7B5);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.btn-turquoise:hover {
  background-color: var(--turquoise-deep, #26A194);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.content-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  text-align: center;
  margin: 20px 0;
}

.placeholder-icon {
  background-color: rgba(25, 118, 210, 0.1);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.placeholder-icon .material-icons {
  font-size: 40px;
  color: #1976D2;
}

.content-placeholder h3 {
  font-size: 1.5rem;
  color: #455a64;
  margin-bottom: 16px;
}

.content-placeholder p {
  color: #78909c;
  max-width: 500px;
  margin: 0 auto 8px;
  line-height: 1.5;
}
</style>
